import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const EmailHistoryTable = ({ onRowClick, searchTerm, dateFilter, sortBy, emailCategory }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: 'dateTime', direction: 'desc' });
  const [editingTag, setEditingTag] = useState(null);
  const [tagInput, setTagInput] = useState('');
  const [customerPopup, setCustomerPopup] = useState(null);
  const itemsPerPage = 10;

  const emailHistoryData = [
    {
      id: 'EMAIL-2026-001',
      dateTime: '2026-01-02T10:30:00',
      customerName: 'Priya Sharma',
      mobileNumber: '+91 98765 43210',
      concernCategory: 'Wrong Item Received',
      emailCategory: 'New - Action Required',
      status: 'Pending',
      callDuration: '2m 45s',
      recordingUrl: '#',
      attachment: 'invoice.pdf',
      product: 'Neon Skull Crew Socks Pack of 5',
      ticketId: 'TKT-8472',
      aiAgent: 'AI Agent - Orders',
      tags: ['urgent', 'wrong-item'],
      emailThread: [
        { from: 'priya.sharma@gmail.com', to: 'support@thesockstreet.com', subject: 'Received wrong socks in my order', date: '2026-01-02T10:30:00', body: 'I ordered the Neon Skull Pack of 5 but received the Shadow Spectrum pack instead. Please send the correct item.', attachments: ['invoice.pdf'] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5421',
        orderValue: '\u20B91,199',
        customerType: 'Repeat',
        pastEscalations: 2
      }
    },
    {
      id: 'EMAIL-2026-002',
      dateTime: '2026-01-02T09:15:00',
      customerName: 'Amit Patel',
      mobileNumber: '+91 87654 32109',
      concernCategory: 'Order Status',
      emailCategory: 'Ongoing Thread - Informational',
      status: 'Resolved',
      callDuration: '2m 18s',
      recordingUrl: '#',
      attachment: null,
      product: 'Colorwave Crew Socks Pack of 3',
      ticketId: 'TKT-8473',
      aiAgent: 'AI Agent - Shipping',
      tags: ['tracking', 'resolved'],
      emailThread: [
        { from: 'amit.patel@gmail.com', to: 'support@thesockstreet.com', subject: 'Order not delivered yet', date: '2026-01-02T09:15:00', body: 'My order was supposed to arrive 3 days ago but tracking still shows in transit. Can you check?', attachments: [] },
        { from: 'support@thesockstreet.com', to: 'amit.patel@gmail.com', subject: 'Re: Order not delivered yet', date: '2026-01-02T09:20:00', body: 'We have escalated this with the courier. Your order will be delivered by tomorrow.', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5422',
        orderValue: '\u20B9640',
        customerType: 'New',
        pastEscalations: 0
      }
    },
    {
      id: 'EMAIL-2026-003',
      dateTime: '2026-01-02T08:45:00',
      customerName: 'Neha Gupta',
      mobileNumber: '+91 76543 21098',
      concernCategory: 'Delivery Issue',
      emailCategory: 'New - Informational',
      status: 'Closed',
      callDuration: '1m 42s',
      recordingUrl: '#',
      attachment: 'tracking.png',
      product: 'Sneaker Ankle Socks Pack of 3',
      ticketId: null,
      aiAgent: 'AI Agent - Delivery',
      tags: ['tracking', 'delivery'],
      emailThread: [
        { from: 'neha.gupta@yahoo.com', to: 'support@thesockstreet.com', subject: 'Where is my order?', date: '2026-01-02T08:45:00', body: 'My order was supposed to arrive yesterday. Can you check the delivery status?', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5423',
        orderValue: '\u20B9384',
        customerType: 'Repeat',
        pastEscalations: 1
      }
    },
    {
      id: 'EMAIL-2026-004',
      dateTime: '2026-01-01T16:20:00',
      customerName: 'Rajesh Kumar',
      mobileNumber: '+91 99887 76655',
      concernCategory: 'Order Cancellation',
      emailCategory: 'Ongoing Thread - Action Required',
      status: 'Pending',
      callDuration: '2m 32s',
      recordingUrl: '#',
      attachment: null,
      product: 'Willow\'s Edge Crew Socks Pack of 3',
      ticketId: 'TKT-8474',
      aiAgent: 'AI Agent - Orders',
      tags: ['cancellation', 'refund'],
      emailThread: [
        { from: 'rajesh.kumar@outlook.com', to: 'support@thesockstreet.com', subject: 'Cancel my order', date: '2026-01-01T16:20:00', body: 'I want to cancel my order. I ordered the wrong size by mistake.', attachments: [] },
        { from: 'support@thesockstreet.com', to: 'rajesh.kumar@outlook.com', subject: 'Re: Cancel my order', date: '2026-01-01T16:25:00', body: 'Your order has already been shipped. Would you like to initiate a return instead?', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5424',
        orderValue: '\u20B9640',
        customerType: 'Repeat',
        pastEscalations: 0
      }
    },
    {
      id: 'EMAIL-2026-005',
      dateTime: '2026-01-01T14:50:00',
      customerName: 'Anita Verma',
      mobileNumber: '+91 88776 65544',
      concernCategory: 'Size Exchange',
      emailCategory: 'New - Action Required',
      status: 'Resolved',
      callDuration: '1m 55s',
      recordingUrl: '#',
      attachment: 'return_label.pdf',
      product: 'Specticals Charm Crew Socks Pack of 5',
      ticketId: 'TKT-8475',
      aiAgent: 'AI Agent - Returns',
      tags: ['exchange', 'size-issue'],
      emailThread: [
        { from: 'anita.verma@gmail.com', to: 'support@thesockstreet.com', subject: 'Size exchange request', date: '2026-01-01T14:50:00', body: 'The socks I received are too tight. I need to exchange for a larger size.', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5425',
        orderValue: '\u20B9999',
        customerType: 'New',
        pastEscalations: 0
      }
    },
    {
      id: 'EMAIL-2026-006',
      dateTime: '2026-01-01T13:30:00',
      customerName: 'Vikram Singh',
      mobileNumber: '+91 77665 54433',
      concernCategory: 'Damaged Product',
      emailCategory: 'Ongoing Thread - Action Required',
      status: 'Pending',
      callDuration: '2m 58s',
      recordingUrl: '#',
      attachment: 'damage_photo.jpg',
      product: 'Neon Skull Combo Pack of 10',
      ticketId: 'TKT-8476',
      aiAgent: 'AI Agent - Quality',
      tags: ['damaged', 'replacement'],
      emailThread: [
        { from: 'vikram.singh@gmail.com', to: 'support@thesockstreet.com', subject: 'Damaged socks and wristband received', date: '2026-01-01T13:30:00', body: 'The combo pack arrived with torn packaging and two pairs of socks have holes in them.', attachments: ['damage_photo.jpg'] },
        { from: 'support@thesockstreet.com', to: 'vikram.singh@gmail.com', subject: 'Re: Damaged socks and wristband received', date: '2026-01-01T13:35:00', body: 'We apologize for this. Processing immediate replacement for the damaged items.', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5426',
        orderValue: '\u20B91,450',
        customerType: 'Repeat',
        pastEscalations: 1
      }
    },
    {
      id: 'EMAIL-2026-007',
      dateTime: '2026-01-01T11:15:00',
      customerName: 'Kavita Reddy',
      mobileNumber: '+91 93456 78901',
      concernCategory: 'Quality Complaint',
      emailCategory: 'New - Informational',
      status: 'Closed',
      callDuration: '1m 38s',
      recordingUrl: '#',
      attachment: null,
      product: 'Highland Mist Crew Socks Pack of 3',
      ticketId: 'TKT-8477',
      aiAgent: 'AI Agent - Support',
      tags: ['quality', 'color-fading'],
      emailThread: [
        { from: 'kavita.reddy@yahoo.com', to: 'support@thesockstreet.com', subject: 'Color fading after first wash', date: '2026-01-01T11:15:00', body: 'The socks color faded significantly after the first wash. Is this normal?', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5427',
        orderValue: '\u20B9640',
        customerType: 'New',
        pastEscalations: 0
      }
    },
    {
      id: 'EMAIL-2026-008',
      dateTime: '2026-01-01T10:00:00',
      customerName: 'Suresh Nair',
      mobileNumber: '+91 82345 67890',
      concernCategory: 'Product Inquiry',
      emailCategory: 'New - Informational',
      status: 'Closed',
      callDuration: '2m 10s',
      recordingUrl: '#',
      attachment: null,
      product: 'Running Ankle Socks - Daylight Drip Pack of 3',
      ticketId: null,
      aiAgent: 'AI Agent - Product Info',
      tags: ['product-info', 'size-guide'],
      emailThread: [
        { from: 'suresh.nair@gmail.com', to: 'support@thesockstreet.com', subject: 'Size guide for running socks', date: '2026-01-01T10:00:00', body: 'What size should I order for shoe size 10 UK? Also, are these socks suitable for long runs?', attachments: [] }
      ],
      customerInfo: {
        orderId: null,
        orderValue: 'N/A',
        customerType: 'Prospect',
        pastEscalations: 0
      }
    },
    {
      id: 'EMAIL-2026-009',
      dateTime: '2025-12-31T15:45:00',
      customerName: 'Deepika Joshi',
      mobileNumber: '+91 91234 56789',
      concernCategory: 'Refund Not Received',
      emailCategory: 'Ongoing Thread - Action Required',
      status: 'Pending',
      callDuration: '2m 52s',
      recordingUrl: '#',
      attachment: 'screenshot.png',
      product: 'Trending Now Crew Socks Pack of 3',
      ticketId: 'TKT-8478',
      aiAgent: 'AI Agent - Payments',
      tags: ['refund-pending', 'priority'],
      emailThread: [
        { from: 'deepika.joshi@outlook.com', to: 'support@thesockstreet.com', subject: 'Refund not received for returned order', date: '2025-12-31T15:45:00', body: 'I returned my order 10 days ago but still have not received the refund. The return was accepted.', attachments: ['screenshot.png'] },
        { from: 'support@thesockstreet.com', to: 'deepika.joshi@outlook.com', subject: 'Re: Refund not received for returned order', date: '2025-12-31T15:50:00', body: 'We are checking with our payments team. Will update you shortly.', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5428',
        orderValue: '\u20B9699',
        customerType: 'Repeat',
        pastEscalations: 3
      }
    },
    {
      id: 'EMAIL-2026-010',
      dateTime: '2025-12-31T14:20:00',
      customerName: 'Manish Agarwal',
      mobileNumber: '+91 85678 90123',
      concernCategory: 'Payment Failed',
      emailCategory: 'New - Action Required',
      status: 'Resolved',
      callDuration: '1m 48s',
      recordingUrl: '#',
      attachment: null,
      product: 'Love Drip K-Edition Dark Ankle Socks Pack of 3',
      ticketId: 'TKT-8479',
      aiAgent: 'AI Agent - Payments',
      tags: ['payment-failed', 'resolved'],
      emailThread: [
        { from: 'manish.agarwal@gmail.com', to: 'support@thesockstreet.com', subject: 'Payment deducted but order not placed', date: '2025-12-31T14:20:00', body: 'My payment of Rs 599 was deducted but the order shows as failed. Please help.', attachments: [] }
      ],
      customerInfo: {
        orderId: 'ORD-2026-5429',
        orderValue: '\u20B9599',
        customerType: 'Repeat',
        pastEscalations: 1
      }
    }
  ];

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    return date?.toLocaleString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric',
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const handleSort = (key) => {
    setSortConfig({
      key,
      direction: sortConfig?.key === key && sortConfig?.direction === 'asc' ? 'desc' : 'asc'
    });
  };

  const handleAddTag = (emailId) => {
    if (tagInput?.trim()) {
      setTagInput('');
      setEditingTag(null);
    }
  };

  const handleRemoveTag = (emailId, tag) => {
    // Tag removal logic
  };

  const getStatusColor = (status) => {
    const colors = {
      'Pending': 'bg-warning/10 text-warning',
      'Closed': 'bg-muted text-muted-foreground',
      'Resolved': 'bg-success/10 text-success'
    };
    return colors?.[status] || 'bg-muted text-muted-foreground';
  };

  const getEmailCategoryColor = (category) => {
    const colors = {
      'New - Informational': 'bg-primary/10 text-primary',
      'New - Action Required': 'bg-error/10 text-error',
      'Ongoing Thread - Informational': 'bg-secondary/10 text-secondary',
      'Ongoing Thread - Action Required': 'bg-warning/10 text-warning'
    };
    return colors?.[category] || 'bg-muted text-muted-foreground';
  };

  // Filter emails based on search, date, and category
  const filteredEmails = emailHistoryData?.filter(email => {
    const matchesSearch = !searchTerm || 
      email?.customerName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      email?.id?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
      email?.concernCategory?.toLowerCase()?.includes(searchTerm?.toLowerCase());
    
    const matchesCategory = !emailCategory || emailCategory === 'All Emails' || email?.emailCategory === emailCategory;
    
    // Date filtering logic would go here
    const matchesDate = true; // Simplified for now
    
    return matchesSearch && matchesCategory && matchesDate;
  });

  // Sort emails
  const sortedEmails = [...filteredEmails]?.sort((a, b) => {
    if (sortBy === 'oldest') {
      return new Date(a?.dateTime) - new Date(b?.dateTime);
    } else {
      return new Date(b?.dateTime) - new Date(a?.dateTime);
    }
  });

  const totalPages = Math.ceil(sortedEmails?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedEmails = sortedEmails?.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6">
      <div className="mb-4 md:mb-6">
        <h3 className="text-base md:text-lg font-semibold text-foreground">Email History</h3>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full min-w-[1400px]">
          <thead>
            <tr className="border-b border-border">
              <th 
                className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground cursor-pointer hover:text-foreground transition-base"
                onClick={() => handleSort('dateTime')}
              >
                <div className="flex items-center gap-1">
                  Date & Time
                  <Icon name={sortConfig?.key === 'dateTime' ? (sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown') : 'ChevronsUpDown'} size={14} />
                </div>
              </th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Customer Name</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Mobile Number</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Concern Category</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Email Category</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Status</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Call Duration</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Recording</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Attachment</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Product</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Ticket ID</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">AI Agent</th>
              <th className="text-left py-3 px-4 text-xs md:text-sm font-medium text-muted-foreground">Tags</th>
            </tr>
          </thead>
          <tbody>
            {paginatedEmails?.map((email) => (
              <tr 
                key={email?.id} 
                className="border-b border-border hover:bg-muted/50 transition-base cursor-pointer"
                onClick={() => onRowClick(email)}
              >
                <td className="py-3 px-4">
                  <span className="text-xs md:text-sm text-foreground">{formatDateTime(email?.dateTime)}</span>
                </td>
                <td className="py-3 px-4">
                  <button
                    onClick={(e) => {
                      e?.stopPropagation();
                      setCustomerPopup(email?.customerInfo);
                    }}
                    className="text-xs md:text-sm font-medium text-primary hover:underline"
                  >
                    {email?.customerName}
                  </button>
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs md:text-sm text-foreground font-mono">{email?.mobileNumber}</span>
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs md:text-sm text-foreground">{email?.concernCategory}</span>
                </td>
                <td className="py-3 px-4">
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${getEmailCategoryColor(email?.emailCategory)}`}>
                    {email?.emailCategory}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${getStatusColor(email?.status)}`}>
                    {email?.status}
                  </span>
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs md:text-sm text-foreground">{email?.callDuration}</span>
                </td>
                <td className="py-3 px-4">
                  <button 
                    onClick={(e) => e?.stopPropagation()}
                    className="p-2 hover:bg-primary/10 rounded-lg transition-base"
                    title="Play recording"
                  >
                    <Icon name="Play" size={16} className="text-primary" />
                  </button>
                </td>
                <td className="py-3 px-4">
                  {email?.attachment ? (
                    <button 
                      onClick={(e) => e?.stopPropagation()}
                      className="flex items-center gap-1 text-xs text-primary hover:underline"
                    >
                      <Icon name="Paperclip" size={14} />
                      View
                    </button>
                  ) : (
                    <span className="text-xs text-muted-foreground">-</span>
                  )}
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs md:text-sm text-foreground">{email?.product}</span>
                </td>
                <td className="py-3 px-4">
                  {email?.ticketId ? (
                    <span className="text-xs font-mono text-accent">{email?.ticketId}</span>
                  ) : (
                    <span className="text-xs text-muted-foreground">-</span>
                  )}
                </td>
                <td className="py-3 px-4">
                  <span className="text-xs text-foreground">{email?.aiAgent}</span>
                </td>
                <td className="py-3 px-4">
                  <div className="flex flex-wrap gap-1">
                    {email?.tags?.map((tag, index) => (
                      <span
                        key={index}
                        className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-xs"
                      >
                        {tag}
                        <button
                          onClick={(e) => {
                            e?.stopPropagation();
                            handleRemoveTag(email?.id, tag);
                          }}
                          className="hover:text-error transition-base"
                        >
                          <Icon name="X" size={10} />
                        </button>
                      </span>
                    ))}
                    {editingTag === email?.id ? (
                      <input
                        type="text"
                        value={tagInput}
                        onChange={(e) => setTagInput(e?.target?.value)}
                        onKeyDown={(e) => {
                          e?.stopPropagation();
                          if (e?.key === 'Enter') handleAddTag(email?.id);
                          if (e?.key === 'Escape') setEditingTag(null);
                        }}
                        onBlur={() => setEditingTag(null)}
                        className="w-20 px-1 py-0.5 text-xs border border-border rounded"
                        autoFocus
                        onClick={(e) => e?.stopPropagation()}
                      />
                    ) : (
                      <button
                        onClick={(e) => {
                          e?.stopPropagation();
                          setEditingTag(email?.id);
                        }}
                        className="p-1 hover:bg-primary/10 rounded transition-base"
                        title="Add tag"
                      >
                        <Icon name="Plus" size={12} className="text-primary" />
                      </button>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-between mt-4 md:mt-6 gap-3">
        <p className="text-xs md:text-sm text-muted-foreground">
          Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, sortedEmails?.length)} of {sortedEmails?.length} emails
        </p>
        <div className="flex items-center gap-2">
          <button
            onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
            disabled={currentPage === 1}
            className="px-3 py-2 border border-border rounded-lg text-xs md:text-sm font-medium text-foreground disabled:opacity-50 disabled:cursor-not-allowed hover:bg-muted transition-base"
          >
            <Icon name="ChevronLeft" size={16} />
          </button>
          <span className="text-xs md:text-sm text-foreground px-3">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
            disabled={currentPage === totalPages}
            className="px-3 py-2 border border-border rounded-lg text-xs md:text-sm font-medium text-foreground disabled:opacity-50 disabled:cursor-not-allowed hover:bg-muted transition-base"
          >
            <Icon name="ChevronRight" size={16} />
          </button>
        </div>
      </div>

      {customerPopup && (
        <div 
          className="fixed inset-0 z-[500] flex items-center justify-center bg-black/50 p-4"
          onClick={() => setCustomerPopup(null)}
        >
          <div 
            className="bg-card rounded-lg border border-border p-6 w-full max-w-md shadow-xl"
            onClick={(e) => e?.stopPropagation()}
          >
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-foreground">Customer Information</h3>
              <button
                onClick={() => setCustomerPopup(null)}
                className="flex items-center justify-center w-8 h-8 rounded-lg hover:bg-muted transition-base"
              >
                <Icon name="X" size={20} />
              </button>
            </div>
            <div className="space-y-3">
              <div>
                <p className="text-xs text-muted-foreground mb-1">Order ID</p>
                <p className="text-sm font-medium text-foreground">{customerPopup?.orderId || 'N/A'}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Order Value</p>
                <p className="text-sm font-medium text-foreground">{customerPopup?.orderValue}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Product</p>
                <p className="text-sm font-medium text-foreground">{customerPopup?.product || 'N/A'}</p>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Customer Type</p>
                <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${
                  customerPopup?.customerType === 'New' ? 'bg-success/10 text-success' :
                  customerPopup?.customerType === 'Repeat' ? 'bg-primary/10 text-primary' : 'bg-warning/10 text-warning'
                }`}>
                  {customerPopup?.customerType}
                </span>
              </div>
              <div>
                <p className="text-xs text-muted-foreground mb-1">Past Escalations Count</p>
                <p className="text-sm font-medium text-foreground">{customerPopup?.pastEscalations}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EmailHistoryTable;